import { Switch } from '@headlessui/react';
import React, { useState } from 'react';
import { classNames } from '@/lib/classNames';
import useTeams from '@/hooks/useTeams';
import { NewButton } from '@/components/basic';
import { Theme } from '@/components/basic/NewButton';
import { SearchableList } from '@/components/partial/SearchableList/SearchableList';
import { TeamListItem } from '@/components/partial/UserSettingsPanel/TeamListItem';
import { ITeam } from '@gettactic/api';
function useTeamListAndRequired(userIds: string[], query: string) {
  //@todo complete users with what is listed on userIds
  const { teamList } = useTeams({ type: 'directory', hidden: true });
  return {
    list: (teamList?.elements ?? []).filter(
      (x: ITeam) => !query || x.name.toLowerCase().indexOf(query.toLowerCase()) > -1
    )
  };
}

type Props = {
  ids: string[];
  add: (id: string) => void;
  remove: (id: string) => void;
};
export default function TeamsPermissionList({ ids, add, remove }: Props) {
  const [currentOver, setCurrentOver] = useState('');
  const [query, setQuery] = useState('');
  const [displayOnlyAssigned, setDisplayOnlyAssigned] = useState(false);
  const { list } = useTeamListAndRequired(ids, query);
  return (
    <SearchableList
      teamSearchQuery={query}
      setSearchQuery={setQuery}
      actionElement={
        <Switch.Group>
          <div className="flex items-center gap-3">
            <Switch.Label className="text-base font-medium text-gray-900">
              All
            </Switch.Label>
            <Switch
              checked={displayOnlyAssigned}
              onChange={() => setDisplayOnlyAssigned((x) => !x)}
              className={`${
                displayOnlyAssigned ? 'bg-primary' : 'bg-disabled'
              } relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2`}
            >
              <span
                className={classNames(
                  displayOnlyAssigned ? 'translate-x-5' : 'translate-x-0',
                  'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                )}
              />
            </Switch>
            <Switch.Label className="text-base font-medium text-gray-900">
              Can Reserve
            </Switch.Label>
          </div>
        </Switch.Group>
      }
    >
      {list
        ? list.map((team: ITeam) => {
            const alreadyIn = ids.indexOf(team.id) > -1;
            if (displayOnlyAssigned && !alreadyIn) {
              return <></>;
            }
            return (
              <TeamListItem
                key={team.id}
                team={team}
                rightElement={
                  <NewButton.Component
                    variant={NewButton.Variant.PrimaryShort}
                    size={NewButton.Size.Medium}
                    theme={alreadyIn ? Theme.Primary : Theme.Base}
                    onMouseOver={() => setCurrentOver(team.id)}
                    onMouseLeave={() => setCurrentOver('')}
                    onClick={() => (alreadyIn ? remove(team.id) : add(team.id))}
                  >
                    {alreadyIn
                      ? currentOver === team.id
                        ? 'Remove'
                        : 'Can Reserve'
                      : 'Add'}
                  </NewButton.Component>
                }
              />
            );
          })
        : null}
    </SearchableList>
  );
}
